
















import { defineComponent, ref, computed } from '~/utils/nuxt3-migration'
import LoanCalculatorModal from '~/components/car/classifieds/view/partials/loans/calculator/LoanCalculatorModal.vue'
import { v4 as uuidv4 } from 'uuid'
import { OnlineLoanType } from '~/constants/loan/loans'

export default defineComponent({
  components: { LoanCalculatorModal },
  props: {
    loanInstallmentsFromParent: {
      type: Number,
      default: 48
    },
    loanAmountFromParent: {
      type: Number,
      default: 15000
    }
  },
  setup() {
    const loanModalIsShown = ref(false)

    const sessionId = computed(() => uuidv4())

    function handleGetALoanButtonClick() {
      loanModalIsShown.value = true
    }
    return {
      loanModalIsShown,
      sessionId,
      OnlineLoanType,
      handleGetALoanButtonClick
    }
  }
})
